module.exports = __webpack_public_path__ + "static/media/plane(9).b3a5efe6.PNG";